import { all, call, put, takeLatest } from "redux-saga/effects";
import { ReservationsAPI } from "../../../api/reservationsAPI";
import { processReservationsData } from "../../../utils/dataProcessingUtils";
import {
  GET_RESERVATIONS_DATA_REQUEST,
  GET_RESERVATIONS_DATA_SUCCESS,
  GET_RESERVATIONS_DATA_ERROR,
} from "../../actions";

function* workerReservationsData(action: {
  type: string;
  payload: string[];
}): Generator<any> {
  try {
    const data: any = yield all([
      call(ReservationsAPI.getGuestReservations, action.payload),
      call(ReservationsAPI.getOwnerReservations, action.payload),
    ]);

    const guestReservations = data?.[0];
    const ownerReservations = data?.[1]?.map((reservation: any) => ({
      ...reservation,
      source: "owner",
    }));

    const flattenedData = [guestReservations, ownerReservations]
      .flat()
      .filter(Boolean);

    yield put({
      type: GET_RESERVATIONS_DATA_SUCCESS,
      payload: {
        reservations: flattenedData,
        reservationsMap: processReservationsData(flattenedData),
      },
    });
  } catch (error: any) {
    yield put({
      type: GET_RESERVATIONS_DATA_ERROR,
      payload: { message: error.message },
    });
  }
}

export function* watcherReservationsData() {
  yield takeLatest(GET_RESERVATIONS_DATA_REQUEST, workerReservationsData);
}
